import { render, staticRenderFns } from "./UpdateService.vue?vue&type=template&id=55888bd2&"
import script from "./UpdateService.vue?vue&type=script&lang=js&"
export * from "./UpdateService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports